import { IconButton, Tooltip, Typography, Box } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { formatDistanceToNow } from 'date-fns';

interface RefreshButtonProps {
  onRefresh: () => void;
  lastUpdated: string;
  loading?: boolean;
}

export default function RefreshButton({ onRefresh, lastUpdated, loading }: RefreshButtonProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="caption" color="text.secondary">
        Updated {formatDistanceToNow(new Date(lastUpdated), { addSuffix: true })}
      </Typography>
      <Tooltip title="Refresh data">
        <IconButton
          onClick={onRefresh}
          disabled={loading}
          size="small"
          sx={{
            '&:hover': {
              backgroundColor: 'action.hover',
            },
            animation: loading ? 'spin 1s linear infinite' : 'none',
            '@keyframes spin': {
              '0%': {
                transform: 'rotate(0deg)',
              },
              '100%': {
                transform: 'rotate(360deg)',
              },
            },
          }}
        >
          <RefreshIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
